module.exports = __webpack_public_path__ + "img/swiper9.c170771f.jpg";